import { Box, Icon, ListRow, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

export const NoAccountsRow: React.FC = () => (
  <SambaAutoLink
    to={urlBuilder.appExternalAccounts.absolute()}
    css={{ textDecoration: 'none!important' }}
    onClick={() => trackClick({ name: 'AddExternalAccount', location: 'Home', module: 'EmptyExternalAccounts' })}
  >
    <ListRow>
      <ListRow.LeadingAsset>
        <Box
          css={{
            background: 'background',
            borderRadius: 'medium',
            height: '36px',
            width: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon name="Bank" size="xsmall" color="icon" />
        </Box>
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <Text color="text">Connect your other accounts</Text>
        <Text variant="text50" color="text.weak">
          Connect your other accounts for a more complete picture of your financial situation.
        </Text>
      </ListRow.LeadingContent>
      <ListRow.TrailingAsset>
        <Icon name="CaretRight" size="small" color="icon" />
      </ListRow.TrailingAsset>
    </ListRow>
  </SambaAutoLink>
);
